import React from 'react';
import PropTypes from 'prop-types';
import { Group } from '../../../../assets/images';
import Icon from '../Icon';

import {
  WrapperResultItem,
  WrapperHeaderGroup,
  WrapperIcon,
  WrapperBody,
  ResultTitle
} from './style';

const GroupItem = ({ className, title, urlLink, onClick }) => (
  <WrapperResultItem className={className} to={urlLink} onClick={onClick}>
    <WrapperBody>
      <WrapperHeaderGroup>
        <WrapperIcon>
          <Icon svg={Group} size="m" hover />
        </WrapperIcon>
        <ResultTitle>{title}</ResultTitle>
      </WrapperHeaderGroup>
    </WrapperBody>
  </WrapperResultItem>
);

GroupItem.propTypes = {
  className: PropTypes.string,
  urlLink: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func
};

GroupItem.defaultProps = {
  urlLink: '/'
};

export default GroupItem;
